import { Component, ViewEncapsulation, Inject, OnDestroy, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { Category } from 'src/@omnial/_models/catalog/category.model';
import { ProductDetail } from 'src/@omnial/_models/catalog/product.model';
import { AfterpayLimits } from 'src/@omnial/_models/external/afterpay-config.model';
import { AfterpayService } from 'src/@omnial/_payments/afterpay.service';
import { CatalogService } from 'src/@omnial/_services/catalog/catalog.service';
import { TrackingService } from 'src/@omnial/_services/external/tracking.service';


@Component({
    selector: 'app-product-dialog',
    templateUrl: './../../../app/shared/product-dialog/product-dialog.component.html',
    styleUrls: ['./../../../app/shared/product-dialog/product-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class ProductDialogComponent implements OnDestroy, AfterViewInit {
  public product: ProductDetail;
  public category: Category;
  public listId: string;
  public afterpayLimits: AfterpayLimits;
  public afterpayPop = false;
  public productAvailable = true;
  public subscriptions: Subscription[] = [];

  constructor(
    public dialogRef: MatDialogRef<ProductDialogComponent>,
    public catalogService: CatalogService,
    public afterpayService: AfterpayService,
    public trackingService: TrackingService,
    public spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: { product: ProductDetail, category: Category, listId: string }) {
    if (data?.product) {
      this.product = data.product;
    }
    if (data?.category) {
      this.category = data.category;
    }
    if (data?.listId) {
      this.listId = data.listId;
    }
    if (this.product.stockQuantity > 0) {
      this.productAvailable = true;
    } else {
      this.productAvailable = false;
    }
    this.trackingService.pushProductView(this.product, this.listId, 'Quick View');
    this.subscriptions.push(this.afterpayService.limits.subscribe(res => { this.afterpayLimits = res as AfterpayLimits; }));
  }

  ngAfterViewInit(): void {
    this.spinner.hide();
    // Scroll fix on iPhones
    setTimeout(() => {
      var content = document.getElementsByClassName("mat-mdc-dialog-surface");
      if (content?.length > 0) {
        content[0].scrollTo(0, 0);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => { sub.unsubscribe(); });
    }
  }

  public close(): void {
    this.dialogRef.close();
  }

  public openAfterpay(): void {
    this.afterpayPop = true;
  }

  public closeAfterpay(): void {
    this.afterpayPop = false;
  }
}
